import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper";

import avatar1 from "../static/images/avatar1.jpg";
import avatar2 from "../static/images/avatar2.jpg";
import avatar3 from "../static/images/avatar3.jpg";

export default () => {
  const pagination = {
    el: ".swiper-pagination-container",
    clickable: true,
  };
  return (
    <Swiper
      autoplay={{ delay: 5000, disableOnInteraction: false }}
      pagination={pagination}
      slidesPerView={1}
      spaceBetween={15}
      modules={[Autoplay, Pagination]}
      loop={true}
      className="swiper_container relative h-full  overflow-hidden"
    >
      <SwiperSlide className="single_slide z-10 bg-prime rounded-xl flex items-center">
        <div className="testi_content py-4 px-4 lg:px-16 ">
          <i class="fa-solid fa-quote-right text-[40px] lg:text-[100px] text-white/50"></i>
          <p className="leading-6 text-white mb-3 lg:leading-7">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat
            architecto porro nihil iusto reprehenderit temporibus harum? Iusto
            natus corrupti, cumque modi eius, necessitatibus architecto maxime
            magnam rerum cum eligendi dicta molestiae facere odit illo numquam.
          </p>
          <div className="flex items-center px-4 justify-end ">
            <img
              className="w-16 h-16 rounded-full object-cover"
              src={avatar3}
              alt="Avatar"
            />
            <h4 className="text-xl text-white ml-3 leading-4">
              Avanthika M <br /> <span className="text-xs">Happy Customer</span>
            </h4>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide className="single_slide z-10 bg-prime rounded-xl flex items-center">
        <div className="testi_content py-4 px-4 lg:px-16 ">
          <i class="fa-solid fa-quote-right text-[40px] lg:text-[100px] text-white/50"></i>
          <p className="leading-6 text-white mb-3 lg:leading-7">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat
            architecto porro nihil iusto reprehenderit temporibus harum? Iusto
            natus corrupti, cumque modi eius, necessitatibus architecto maxime
            magnam rerum cum eligendi dicta molestiae facere odit illo numquam.
          </p>
          <div className="flex items-center px-4 justify-end ">
            <img
              className="w-16 h-16 rounded-full object-cover"
              src={avatar2}
              alt="Avatar"
            />
            <h4 className="text-xl text-white ml-3 leading-4">
              Aswin Ram <br /> <span className="text-xs">New Customer</span>
            </h4>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide className="single_slide z-10 bg-prime rounded-xl flex items-center">
        <div className="testi_content py-4 px-4 lg:px-16 ">
          <i class="fa-solid fa-quote-right text-[40px] lg:text-[100px] text-white/50"></i>
          <p className="leading-6 text-white mb-3 lg:leading-7">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat
            architecto porro nihil iusto reprehenderit temporibus harum? Iusto
            natus corrupti, cumque modi eius, necessitatibus architecto maxime
            magnam rerum cum eligendi dicta molestiae facere odit illo numquam.
          </p>
          <div className="flex items-center px-4 justify-end ">
            <img
              className="w-16 h-16 rounded-full object-cover"
              src={avatar1}
              alt="Avatar"
            />
            <h4 className="text-xl text-white ml-3 leading-4 capitalize">
              John Abraham <br />{" "}
              <span className="text-xs">Happy Customer</span>
            </h4>
          </div>
        </div>
      </SwiperSlide>

      <div className="!absolute inline-block bottom-0 right-5 z-20">
        <div className="swiper-pagination-container "></div>
      </div>
    </Swiper>
  );
};
